import { render, staticRenderFns } from "./ShareUp.vue?vue&type=template&id=9ef7cf24&scoped=true"
import script from "./ShareUp.vue?vue&type=script&lang=js"
export * from "./ShareUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef7cf24",
  null
  
)

export default component.exports